<div [formGroup]='registerForm' class='has-validation form-check form-check-inline mt-3 mb-3'>
  <input id='signUpCondition' type='checkbox' class='form-check-input' [formControl]='registerForm.controls.signUpCondition'
         [ngClass]="{ 'is-invalid': isInvalid() }"
  >
  <label for='signUpCondition' class='form-check-label'><span [innerHTML]="'signIn.condition' | translate"></span></label>
  <div class='invalid-feedback alert alert-danger' translate='signIn.conditionError'></div>
</div>

